import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from './core/auth/_guards/auth.guard';
import {BaseComponent} from './views/theme/base/base.component';


const routes: Routes = [
  { path: 'iniciar', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule) },
  { path: 'oops', loadChildren: () => import('./views/pages/error/error.module').then(m => m.ErrorModule) },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'boarding',
        loadChildren: () => import('./views/pages/boarding/boarding.module').then(m => m.BoardingModule),
      },
      { path: '', redirectTo: 'boarding', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'oops', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
